export type SoftFloorPeriod = 'Day' | 'Hr' | 'Min';

const getParsedValue = (value?: string) => {
  const parsedValue = parseInt(value ?? '', 10);

  return Number.isFinite(parsedValue) ? parsedValue : 0;
};

const padPeriodValue = (value: number) => value.toString().padStart(2, '0');

export const getSoftFloorPeriodParts = (period?: string) => {
  if (!period) {
    return {
      unit: 'Day' as SoftFloorPeriod,
      value: undefined,
    };
  }

  const [dayHourValue, minuteValue, secondValue] = period.split(':');

  if (!dayHourValue || minuteValue == null) {
    return {
      unit: 'Day' as SoftFloorPeriod,
      value: undefined,
    };
  }

  const [dayValue, hourValue] = dayHourValue.includes('.') ? dayHourValue.split('.', 2) : ['0', dayHourValue];
  const days = getParsedValue(dayValue);
  const hours = getParsedValue(hourValue);
  const minutes = getParsedValue(minuteValue);
  const seconds = getParsedValue(secondValue);
  const unit: SoftFloorPeriod = hours === 0 && minutes === 0 && seconds === 0 ? 'Day' : minutes === 0 && seconds === 0 ? 'Hr' : 'Min';
  const value = unit === 'Day' ? days : unit === 'Hr' ? days * 24 + hours : days * 1440 + hours * 60 + minutes;

  return {
    unit,
    value: Number.isFinite(value) ? value : undefined,
  };
};

export const getSoftFloorPeriodValue = (value: number | undefined, unit: SoftFloorPeriod) => {
  const safeValue = Math.max(0, Math.floor(value ?? 0));

  if (unit === 'Day') {
    return `${safeValue}.00:00:00`;
  }

  if (unit === 'Hr') {
    const days = Math.floor(safeValue / 24);
    const hours = safeValue % 24;

    return `${days}.${padPeriodValue(hours)}:00:00`;
  }

  const days = Math.floor(safeValue / 1440);
  const hours = Math.floor((safeValue % 1440) / 60);
  const minutes = safeValue % 60;

  return `${days}.${padPeriodValue(hours)}:${padPeriodValue(minutes)}:00`;
};
